// extracted by mini-css-extract-plugin
export default {"add":"control_add__u5FA9","tooltip":"control_tooltip__LgRnt"};